<template>
  <div class="home-page">
    <!-- 顶部栏 -->
    <div class="top-bar">
      <div v-if="currentUser" class="user-info" @click.stop="toggleUserMenu">
        <div class="avatar">
          <span>{{ userAvatarText }}</span>
        </div>
        <div class="info">
          <div class="name-row">
            <span class="name">{{ currentUser.nickname || currentUser.username }}</span>
          </div>
          <div class="id-row">
            <span class="id">钻石: {{ diamondBalance }}</span>
          </div>
        </div>
        <div v-if="showUserMenu" class="user-menu">
          <button class="user-menu-item" @click.stop="openRechargeModal">
            钻石充值
          </button>
          <button class="user-menu-item" @click.stop="openInviteModal">
            邀请用户
          </button>
          <div class="user-menu-divider"></div>
          <button class="user-menu-item" @click.stop="openNicknameModal">
            修改昵称
          </button>
          <button class="user-menu-item" @click.stop="openPasswordModal">
            修改密码
          </button>
          <button class="user-menu-item" @click.stop="logout">
            退出登录
          </button>
        </div>
      </div>
      <div class="top-actions">
        <button v-if="!currentUser" class="icon-btn" @click="openAuth('login')">登录</button>
        <button class="icon-btn" @click="showRules = true">规则</button>
      </div>
    </div>

    <div class="home-main-stack">
      <!-- Logo区 -->
      <div class="logo-section">
        <div class="game-logo">
          <div class="logo-main">
            <img src="@/assets/images/logo.png" alt="十三水" class="logo-image">
          </div>
        </div>
      </div>

      <!-- 公告 -->
      <div class="notice-bar">
        <span class="notice-icon">📢</span>
        <span class="notice-text">十三水仅供娱乐，严禁任何形式的赌博行为！</span>
      </div>

      <!-- 主内容区 -->
      <div class="main-content">
        <div class="action-panel">
          <button class="main-btn create-btn" @click="openCreateRoom">
            <span class="btn-glow"></span>
            <span class="btn-icon"><img src="@/assets/images/but_icon1.png" alt="创建房间"></span>
            <span class="btn-text">创建房间</span>
          </button>

          <button class="main-btn join-btn" @click="openJoinRoom">
            <span class="btn-icon"><img src="@/assets/images/but_icon2.png" alt="加入房间"></span>
            <span class="btn-text">加入房间</span>
          </button>

          <button class="main-btn single-btn" @click="openSingleConfig">
            <span class="btn-glow"></span>
            <span class="btn-icon"><img src="@/assets/images/but_icon3.png" alt="单机游戏"></span>
            <span class="btn-text">单机游戏</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 创建房间弹窗 -->
    <div v-if="showCreateModal" class="modal-overlay" @click.self="showCreateModal = false; closeAllHints()">
      <div class="create-room-modal">
        <div class="modal-header">
          <h2>房间设置</h2>
        </div>
        <div class="back-btn">
          <img src="@/assets/images/back.png" @click="showCreateModal = false" alt="返回">
        </div>
        <div class="modal-body">
          <div class="config-area">
            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('局数')">局数 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '局数'" class="hint-tooltip">{{ configHints['局数'] }}</span>
              </span>
              <div class="config-options">
                <label
                  v-for="option in roundOptions"
                  :key="'round-' + option.value"
                  class="check-option"
                  :class="{ active: limitType === 'round' && rounds === option.value }"
                  @click="selectRoundLimit(option.value, option.diamondCost)"
                >
                  <span class="check-box">✓</span>
                  <span>{{ option.label }}</span>
                </label>
                <label
                  v-for="option in durationOptions"
                  :key="'duration-' + option.value"
                  class="check-option"
                  :class="{ active: limitType === 'time' && durationMinutes === option.value }"
                  @click="selectTimeLimit(option.value, option.diamondCost)"
                >
                  <span class="check-box">✓</span>
                  <span>{{ option.label }}</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('人数')">人数 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '人数'" class="hint-tooltip">{{ configHints['人数'] }}</span>
              </span>
              <div class="config-options">
                <label
                  v-for="n in [2, 3, 4, 5, 6, 7, 8]"
                  :key="n"
                  class="check-option"
                  :class="{ active: playerCount === n }"
                  @click="selectPlayerCount(n)"
                >
                  <span class="check-box">✓</span>
                  <span>{{ n }}人</span>
                </label>
              </div>
            </div>

            <div v-if="shouldShowExtraSuitOptions" class="config-row extra-suit-row">
              <span class="config-label hint-label" @click.stop="toggleHint('花牌')">花牌 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '花牌'" class="hint-tooltip">{{ configHints['花牌'] }}</span>
              </span>
              <div class="extra-suit-config">
                <div
                  v-for="suit in extraSuitOptions"
                  :key="suit.value"
                  class="extra-suit-item"
                >
                  <span class="suit-symbol" :class="suit.color">{{ suit.symbol }}</span>
                  <button
                    type="button"
                    class="extra-suit-btn"
                    :disabled="!canDecreaseExtraSuit(suit.value)"
                    @click="changeExtraSuitCount(suit.value, -1)"
                  >-</button>
                  <span class="extra-suit-count">{{ extraSuitCounts[suit.value] || 0 }}</span>
                  <button
                    type="button"
                    class="extra-suit-btn"
                    :disabled="!canIncreaseExtraSuit(suit.value)"
                    @click="changeExtraSuitCount(suit.value, 1)"
                  >+</button>
                </div>
                <div class="extra-suit-summary">
                  已选 {{ totalExtraSuitCount }} / {{ requiredExtraSuitCount }} 副
                </div>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('摆牌时间')">摆牌时间 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '摆牌时间'" class="hint-tooltip">{{ configHints['摆牌时间'] }}</span>
              </span>
              <div class="config-options">
                <label
                  v-for="t in [30, 60, 90]"
                  :key="t"
                  class="check-option"
                  :class="{ active: arrangeTime === t }"
                  @click="arrangeTime = t"
                >
                  <span class="check-box">✓</span>
                  <span>{{ t }}秒</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('发牌方式')">发牌方式 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '发牌方式'" class="hint-tooltip">{{ configHints['发牌方式'] }}</span>
              </span>
              <div class="config-options">
                <label
                  v-for="dm in dealModeOptions"
                  :key="dm.value"
                  class="check-option"
                  :class="{ active: dealMode === dm.value }"
                  @click="dealMode = dm.value"
                >
                  <span class="check-box">✓</span>
                  <span>{{ dm.label }}</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('鬼牌')">鬼牌 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '鬼牌'" class="hint-tooltip">{{ configHints['鬼牌'] }}</span>
              </span>
              <div class="config-options">
                <label class="check-option" :class="{ active: ghostMode === 0 }" @click="ghostMode = 0">
                  <span class="check-box">✓</span>
                  <span>无鬼</span>
                </label>
                <label class="check-option" :class="{ active: ghostMode === 1 }" @click="ghostMode = 1">
                  <span class="check-box">✓</span>
                  <span>单鬼</span>
                </label>
                <label class="check-option" :class="{ active: ghostMode === 2 }" @click="ghostMode = 2">
                  <span class="check-box">✓</span>
                  <span>双鬼</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('打枪奖励')">打枪奖励 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '打枪奖励'" class="hint-tooltip">{{ configHints['打枪奖励'] }}</span>
              </span>
              <div class="config-options score-mode-options">
                <label
                  class="check-option"
                  :class="{ active: sweepScoreType === 'score' }"
                  @click="setSweepScoreType('score')"
                >
                  <span class="check-box">✓</span>
                  <span>分数</span>
                </label>
                <label
                  class="check-option"
                  :class="{ active: sweepScoreType === 'multiplier' }"
                  @click="setSweepScoreType('multiplier')"
                >
                  <span class="check-box">✓</span>
                  <span>倍数</span>
                </label>
              </div>
              <div class="config-options score-value-options">
                <div v-if="sweepScoreType === 'score'" class="score-input-wrap">
                  <input
                    v-model.number="sweepScoreValue"
                    class="score-input"
                    type="number"
                    min="1"
                    max="99"
                    step="1"
                    @blur="normalizeSweepScoreValue"
                  >
                  <span class="score-input-unit">分</span>
                </div>
                <div v-else class="score-input-wrap">
                  <input
                    v-model.number="sweepScoreValue"
                    class="score-input"
                    type="number"
                    min="2"
                    max="99"
                    step="1"
                    @blur="normalizeSweepScoreValue"
                  >
                  <span class="score-input-unit">倍</span>
                </div>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('全垒打翻倍')">全垒打翻倍 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '全垒打翻倍'" class="hint-tooltip">{{ configHints['全垒打翻倍'] }}</span>
              </span>
              <div class="config-options">
                <label class="check-option" :class="{ active: enableHomeRun }" @click="enableHomeRun = true">
                  <span class="check-box">✓</span>
                  <span>启用</span>
                </label>
                <label class="check-option" :class="{ active: !enableHomeRun }" @click="enableHomeRun = false">
                  <span class="check-box">✓</span>
                  <span>关闭</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('奇牌')">奇牌 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '奇牌'" class="hint-tooltip">{{ configHints['奇牌'] }}</span>
              </span>
              <div class="config-options">
                <label class="check-option" :class="{ active: allowOddCards }" @click="allowOddCards = true">
                  <span class="check-box">✓</span>
                  <span>叠加</span>
                </label>
                <label class="check-option" :class="{ active: !allowOddCards }" @click="allowOddCards = false">
                  <span class="check-box">✓</span>
                  <span>不叠加</span>
                </label>
              </div>
            </div>

            <div v-if="allowOddCards" class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('奇牌分')">奇牌分 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '奇牌分'" class="hint-tooltip">{{ configHints['奇牌分'] }}</span>
              </span>
              <div class="config-options special-score-options odd-card-score-options">
                <div
                  v-for="item in rowSpecialScoreOptions"
                  :key="item.key"
                  class="score-input-wrap"
                >
                  <span class="score-input-unit">{{ item.label }}</span>
                  <input
                    v-model.number="rowSpecialScores[item.key]"
                    class="score-input"
                    type="number"
                    min="1"
                    max="99"
                    step="1"
                  >
                </div>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('乌龙')">乌龙 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '乌龙'" class="hint-tooltip">{{ configHints['乌龙'] }}</span>
              </span>
              <div class="config-options">
                <label class="check-option" :class="{ active: allowFouled }" @click="allowFouled = true">
                  <span class="check-box">✓</span>
                  <span>允许</span>
                </label>
                <label class="check-option" :class="{ active: !allowFouled }" @click="allowFouled = false">
                  <span class="check-box">✓</span>
                  <span>不允许</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('马牌')">马牌 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '马牌'" class="hint-tooltip">{{ configHints['马牌'] }}</span>
              </span>
              <div class="config-options score-mode-options">
                <label class="check-option" :class="{ active: enableHorse }" @click="enableHorse = true">
                  <span class="check-box">✓</span>
                  <span>启用</span>
                </label>
                <label class="check-option" :class="{ active: !enableHorse }" @click="enableHorse = false">
                  <span class="check-box">✓</span>
                  <span>关闭</span>
                </label>
              </div>
              <div v-if="enableHorse" class="config-options score-value-options">
                <label
                  v-for="rank in horseRankOptions"
                  :key="'horse-rank-' + rank.value"
                  class="check-option"
                  :class="{ active: horseRank === rank.value }"
                  @click="horseRank = rank.value"
                >
                  <span class="check-box">✓</span>
                  <span>{{ rank.label }}</span>
                </label>
                <label
                  v-for="suit in extraSuitOptions"
                  :key="'horse-suit-' + suit.value"
                  class="check-option"
                  :class="{ active: horseSuit === suit.value }"
                  @click="horseSuit = suit.value"
                >
                  <span class="check-box">✓</span>
                  <span class="suit-symbol" :class="suit.color">{{ suit.symbol }}</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('油菜')">油菜 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '油菜'" class="hint-tooltip">{{ configHints['油菜'] }}</span>
              </span>
              <div class="config-options score-mode-options">
                <label class="check-option" :class="{ active: enableYucai }" @click="enableYucai = true">
                  <span class="check-box">✓</span>
                  <span>启用</span>
                </label>
                <label class="check-option" :class="{ active: !enableYucai }" @click="enableYucai = false">
                  <span class="check-box">✓</span>
                  <span>关闭</span>
                </label>
              </div>
              <div v-if="enableYucai" class="config-options score-value-options">
                <div class="score-input-wrap">
                  <input v-model.number="yucaiScore" class="score-input" type="number" min="0" max="99" step="1">
                  <span class="score-input-unit">分</span>
                </div>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('房间积分')">房间积分 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '房间积分'" class="hint-tooltip">{{ configHints['房间积分'] }}</span>
              </span>
              <div class="config-options score-mode-options">
                <label class="check-option" :class="{ active: allowRoomRate }" @click="allowRoomRate = true">
                  <span class="check-box">✓</span>
                  <span>启用</span>
                </label>
                <label class="check-option" :class="{ active: !allowRoomRate }" @click="allowRoomRate = false">
                  <span class="check-box">✓</span>
                  <span>关闭</span>
                </label>
              </div>
              <div v-if="allowRoomRate" class="config-options score-value-options">
                <div class="score-input-wrap">
                  <input v-model.number="roomRatePercent" class="score-input" type="number" min="1" max="100" step="1">
                  <span class="score-input-unit">%</span>
                </div>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('报到分')">报到分 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '报到分'" class="hint-tooltip">{{ configHints['报到分'] }}</span>
              </span>
              <div class="config-options special-score-options">
                <div
                  v-for="item in specialScoreOptions"
                  :key="item.key"
                  class="score-input-wrap"
                >
                  <span class="score-input-unit">{{ item.label }}</span>
                  <input
                    v-model.number="specialScores[item.key]"
                    class="score-input"
                    type="number"
                    min="1"
                    max="99"
                    step="1"
                  >
                </div>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('随机入座')">随机入座 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === '随机入座'" class="hint-tooltip">{{ configHints['随机入座'] }}</span>
              </span>
              <div class="config-options">
                <label class="check-option" :class="{ active: enableRandomSeat }" @click="enableRandomSeat = true">
                  <span class="check-box">✓</span>
                  <span>是</span>
                </label>
                <label class="check-option" :class="{ active: !enableRandomSeat }" @click="enableRandomSeat = false">
                  <span class="check-box">✓</span>
                  <span>否</span>
                </label>
              </div>
            </div>

            <div class="config-row">
              <span class="config-label hint-label" @click.stop="toggleHint('IP限制')">IP限制 <span class="hint-icon">?</span>
                <span v-if="activeHintKey === 'IP限制'" class="hint-tooltip">{{ configHints['IP限制'] }}</span>
              </span>
              <div class="config-options">
                <label class="check-option" :class="{ active: enableIpLimit }" @click="enableIpLimit = true">
                  <span class="check-box">✓</span>
                  <span>是</span>
                </label>
                <label class="check-option" :class="{ active: !enableIpLimit }" @click="enableIpLimit = false">
                  <span class="check-box">✓</span>
                  <span>否</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="create-submit-btn" @click="confirmConfig">{{ configMode === 'create' ? '创建房间' : '开始游戏' }}</button>
        </div>
      </div>
    </div>

    <!-- 加入房间弹窗 -->
    <div v-if="showJoinModal" class="modal-overlay" @click.self="showJoinModal = false">
      <div class="join-room-modal">
        <div class="join-header">
          <!-- <h2>加入房间</h2> -->
        </div>
        <div class="close-btn">
          <img src="@/assets/images/back.png"  @click="showJoinModal = false" alt="返回">
        </div>
        <div class="join-subtitle">请输入4位数的房间号</div>
        <div class="room-code-display">
          <div
            v-for="(digit, index) in 4"
            :key="index"
            class="code-box"
            :class="{ filled: joinRoomDigits[index] !== undefined }"
          >
            {{ joinRoomDigits[index] !== undefined ? joinRoomDigits[index] : '' }}
          </div>
        </div>
        <div class="num-keyboard">
          <div class="num-row">
            <div v-for="n in [1,2,3,4]" :key="n" class="num-btn" @click="inputDigit(n)">{{ n }}</div>
          </div>
          <div class="num-row">
            <div v-for="n in [5,6,7,8]" :key="n" class="num-btn" @click="inputDigit(n)">{{ n }}</div>
          </div>
          <div class="num-row">
            <div class="num-btn" @click="inputDigit(9)">9</div>
            <div class="num-btn" @click="inputDigit(0)">0</div>
            <div class="num-btn func-btn func-btn-enter" @click="clearDigits">重输</div>
            <div class="num-btn func-btn func-btn-delete" @click="deleteDigit">删除</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 音效开关 -->
    <button
      class="sound-toggle-btn"
      :class="{ muted: soundMuted }"
      @click="toggleSound"
      title="切换音效"
    >
      {{ soundMuted ? '🔇' : '🔊' }}
    </button>

    <!-- 规则弹窗 -->
    <div v-if="showRules" class="modal-overlay" @click.self="showRules = false">
      <div class="rules-modal">
        <div class="rules-header">
          <h2>游戏规则</h2>
          <button class="close-btn" @click="showRules = false">×</button>
        </div>
        <div class="rules-body">
          <h3>基本规则</h3>
          <ul>
            <li>每位玩家获得13张牌，分成三墩：头道(3张)、中道(5张)、尾道(5张)</li>
            <li>摆牌要求：尾道 ≥ 中道 ≥ 头道</li>
            <li>违反规则称为"乌龙"，本局按乌龙规则结算</li>
          </ul>
          <h3>计分规则</h3>
          <ul>
            <li>每墩比较，胜者得1分</li>
            <li>打枪（三墩全赢）：额外+2分</li>
            <li>中道葫芦2分、四条8分、同花顺10分、五条20分</li>
            <li>尾道四条4分、同花顺5分、五条10分</li>
            <li>全垒打（打枪所有玩家）：每家再翻倍</li>
          </ul>
          <h3>特殊牌型</h3>
          <ul>
            <li><strong>一条龙</strong>：A-K各一张，赢每家15分</li>
            <li><strong>六对半</strong>：六对+一张单牌，赢每家7分</li>
            <li><strong>三同花</strong>：三墩均为同花，赢每家7分</li>
            <li><strong>三顺子</strong>：三墩均为顺子，赢每家7分</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 昵称输入弹窗 -->
    <div v-if="showNameModal" class="modal-overlay" @click.self="showNameModal = false">
      <div class="name-modal">
        <div class="name-modal-header">
          <h3>设置昵称</h3>
          <button class="close-btn" @click="showNameModal = false">×</button>
        </div>
        <div class="name-modal-body">
          <input
            ref="nameInput"
            v-model="inputName"
            type="text"
            placeholder="请输入昵称"
            maxlength="10"
            @keyup.enter="confirmName"
          />
          <button class="confirm-name-btn" @click="confirmName">确定</button>
        </div>
      </div>
    </div>

    <!-- 用户登录/注册弹窗 -->
    <div v-if="showAuthModal" class="modal-overlay" @click.self="showAuthModal = false">
      <div class="auth-modal">
        <div class="auth-header">
          <h3>{{ authMode === 'login' ? '用户登录' : '用户注册' }}</h3>
          <button class="close-btn" @click="showAuthModal = false">×</button>
        </div>
        <div class="auth-body">
          <p v-if="inviteReferrerId && !pendingInviteRoomId" class="auth-invite-tip">
            注册后可绑定邀请人
          </p>
          <input v-model.trim="authForm.username" maxlength="20" placeholder="用户名" @keyup.enter="submitAuth">
          <input v-model="authForm.password" type="password" placeholder="密码" @keyup.enter="submitAuth">
          <input
            v-if="authMode === 'register'"
            v-model="authForm.confirmPassword"
            type="password"
            placeholder="确认密码"
            @keyup.enter="submitAuth"
          >
          <input
            v-if="authMode === 'register'"
            v-model.trim="authForm.email"
            type="email"
            placeholder="邮箱（选填）"
            @keyup.enter="submitAuth"
          >
          <input
            v-if="authMode === 'register'"
            v-model.trim="authForm.nickname"
            maxlength="20"
            placeholder="昵称"
            @keyup.enter="submitAuth"
          >
          <div class="auth-switch">
            <button class="link-btn" @click="switchAuthMode">
              {{ authMode === 'login' ? '没有账号，去注册' : '已有账号，去登录' }}
            </button>
          </div>
          <button class="confirm-name-btn" :disabled="authSubmitting" @click="submitAuth">
            {{ authSubmitting ? '提交中...' : (authMode === 'login' ? '登录' : '注册') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <div v-if="showPasswordModal" class="modal-overlay" @click.self="showPasswordModal = false">
      <div class="auth-modal">
        <div class="auth-header">
          <h3>修改密码</h3>
          <button class="close-btn" @click="showPasswordModal = false">×</button>
        </div>
        <div class="auth-body">
          <input v-model="passwordForm.oldPassword" type="password" placeholder="旧密码" @keyup.enter="submitPasswordChange">
          <input v-model="passwordForm.newPassword" type="password" placeholder="新密码" @keyup.enter="submitPasswordChange">
          <input v-model="passwordForm.confirmPassword" type="password" placeholder="确认新密码" @keyup.enter="submitPasswordChange">
          <button class="confirm-name-btn" :disabled="passwordSubmitting" @click="submitPasswordChange">
            {{ passwordSubmitting ? '提交中...' : '确认修改' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 钻石充值弹窗 -->
    <div v-if="showRechargeModal" class="modal-overlay">
      <div class="recharge-modal">
        <div class="auth-header">
          <h3>钻石充值</h3>
          <button class="close-btn" @click="closeRechargeModal">×</button>
        </div>
        <div class="recharge-body">
          <div v-if="rechargeLoading" class="recharge-empty">方案加载中...</div>
          <div v-else-if="!rechargePlans.length" class="recharge-empty">暂无充值方案</div>
          <div v-else class="recharge-grid">
            <button
              v-for="plan in rechargePlans"
              :key="plan.id"
              class="recharge-plan"
              :disabled="rechargeSubmittingId === plan.id"
              @click="createPayOrder(plan)"
            >
              <span class="recharge-title">{{ plan.dlabel || (plan.dictnum + '元') }}</span>
              <span class="recharge-diamond">{{ plan.dvalue }} 钻石</span>
              <span class="recharge-action">{{ rechargeSubmittingId === plan.id ? '创建中...' : '立即充值' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <InviteModal
      :visible="showInviteModal"
      :user-id="currentUser && currentUser.id"
      :user-name="currentUser && (currentUser.nickname || currentUser.username)"
      @close="showInviteModal = false"
    />
    <NicknameModal
      :visible="showNicknameModal"
      v-model="nicknameInput"
      :submitting="nicknameSubmitting"
      @close="closeNicknameModal"
      @confirm="submitNicknameChange"
    />
  </div>
</template>

<script>
import { getMuted, setMuted } from '@/utils/sound'
import md5 from 'blueimp-md5'
import InviteModal from '@/components/InviteModal.vue'
import NicknameModal from '@/components/NicknameModal.vue'
import nicknameMixin from '@/mixins/nickname'
import { appSysRequest, appUserRequest, appPayRequest } from '@/api/request'
export default {
  name: 'Home',
  components: {
    InviteModal,
    NicknameModal
  },
  mixins: [nicknameMixin],
  data() {
    return {
      inputName: '',
      playerCount: 4,
      baseScore: 1,
      arrangeTime: 60,
      enableRandomSeat: true,
      enableIpLimit: true,
      enableSpecialHands: true,
      enableHomeRun: true,
      allowOddCards: false,
      allowFouled: false,
      enableHorse: false,
      horseSuit: 'hearts',
      horseRank: 1,
      enableYucai: false,
      yucaiScore: 0,
      allowRoomRate: false,
      roomRatePercent: 2,
      specialScores: {
        dragonScore: 15,
        allBigScore: 10,
        allSmallScore: 10,
        sixPairsHalfScore: 7,
        threeFlushScore: 7,
        threeStraightScore: 7
      },
      sweepScoreType: 'score',
      sweepScoreValue: 2,
      dealMode: 'single',
      ghostMode: 0,
      dealModeOptions: [
        { value: 'single', label: '单张' },
        { value: '223', label: '223' },
        { value: '334', label: '334' },
        { value: '553', label: '553' },
        { value: 'thirteen', label: '13张' }
      ],
      showRules: false,
      showNameModal: false,
      showCreateModal: false,
      showJoinModal: false,
      joinRoomDigits: [],
      pendingJoinAfterName: false,
      limitType: 'round',
      rounds: 20,
      durationMinutes: 30,
      selectedExtraSuits: [],
      extraSuitCounts: {
        hearts: 0,
        spades: 0,
        clubs: 0,
        diamonds: 0
      },
      rowSpecialScores: {
        frontThreeKind: 3,
        middleFullHouse: 2,
        middleFourKind: 8,
        middleStraightFlush: 10,
        middleFiveKind: 20,
        backFourKind: 4,
        backStraightFlush: 5,
        backFiveKind: 10
      },
      rowSpecialScoreOptions: [
        { key: 'frontThreeKind', label: '头墩三条' },
        { key: 'middleFullHouse', label: '中墩葫芦' },
        { key: 'middleFourKind', label: '中墩炸弹' },
        { key: 'middleStraightFlush', label: '中墩同花顺' },
        { key: 'middleFiveKind', label: '中墩五同' },
        { key: 'backFourKind', label: '尾墩炸弹' },
        { key: 'backStraightFlush', label: '尾墩同花顺' },
        { key: 'backFiveKind', label: '尾墩五同' }
      ],
      extraSuitOptions: [
        { value: 'hearts', label: '红桃', symbol: '♥', color: 'red' },
        { value: 'spades', label: '黑桃', symbol: '♠', color: 'black' },
        { value: 'clubs', label: '梅花', symbol: '♣', color: 'black' },
        { value: 'diamonds', label: '方块', symbol: '♦', color: 'red' }
      ],
      horseRankOptions: [
        { value: 1, label: 'A' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
        { value: 9, label: '9' },
        { value: 10, label: '10' },
        { value: 11, label: 'J' },
        { value: 12, label: 'Q' },
        { value: 13, label: 'K' }
      ],
      specialScoreOptions: [
        { key: 'dragonScore', label: '一条龙' },
        { key: 'allBigScore', label: '全大' },
        { key: 'allSmallScore', label: '全小' },
        { key: 'sixPairsHalfScore', label: '六对半' },
        { key: 'threeFlushScore', label: '三同花' },
        { key: 'threeStraightScore', label: '三顺子' }
      ],
      durationOptions: [],
      roundOptions: [],
      configMode: 'create', // 'create' | 'single'
      soundMuted: false,
      showAuthModal: false,
      authMode: 'login',
      authSubmitting: false,
      currentUser: null,
      diamondBalance: 0,
      showUserMenu: false,
      authForm: {
        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        nickname: ''
      },
      showPasswordModal: false,
      passwordSubmitting: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showRechargeModal: false,
      showInviteModal: false,
      inviteReferrerId: '',
      pendingInviteRoomId: '',
      joiningInvite: false,
      rechargeLoading: false,
      rechargeSubmittingId: null,
      rechargePlans: [],
      
      diamondCost: 0,
      roundCostsLoaded: false,
      durationCostsLoaded: false,
      activeHintKey: null,
      configHints: {
        '局数': '设置房间的游戏局数或时长。创建房间时将根据所选局数/时长消耗对应数量的钻石',
        '人数': '设置参与游戏的玩家数量（2-8人）。超过4人时需选择花牌花色来区分',
        '随机入座': '玩家加入房间时随机分配座位；关闭则按加入顺序依次入座',
        'IP限制': '限制同一IP地址只能有一个账号加入房间，防止同网多开',
        '花牌': '人数超过4人时需增加花牌副数。5人1副，6人2副，7人3副，8人4副；同一花色可重复选择',
        '摆牌时间': '每位玩家摆牌的时间限制。超时将自动使用智能推荐摆牌方案',
        '打枪奖励': '三墩全赢称为"打枪"。可选择按固定分数或倍数给予额外奖励',
        '全垒打翻倍': '当打枪所有对手时，当前局得分再按倍数翻倍',
        '奇牌': '有特殊牌型时，是否在特殊牌型分之外叠加三道特殊牌型分（奇牌分）',
        '奇牌分': '每道特殊牌型的基础积分，同时用于三道比牌赢分和奇牌叠加分',
        '乌龙': '允许或禁止摆牌不符合"尾道≥中道≥头道"规则的情况；允许时可提交，比牌时仍按乌龙结算',
        '马牌': '指定特定花色的牌作为"马牌"。摸到该牌可获得额外加分奖励',
        '油菜': '玩家间的分数差额补偿机制。分数最低的玩家可获得额外补偿分',
        '房间积分': '按房间总积分的一定比例作为额外房间积分进行分配',
        '报到分': '报到特殊牌型（一条龙、全大、全小、六对半、三同花、三顺子）的基础得分设置',
        '发牌方式': '单张：每人轮着发1张；223：先发2张(2轮)再发3张；334：先发3张(2轮)再发4张；553：先发5张(1轮)再发3张；13张：每人一次发完13张',
        '鬼牌': '鬼牌=万能百搭牌，可替代任意牌组成最大牌型。无鬼：不使用鬼牌；单鬼：一副牌加1张鬼；双鬼：一副牌加2张鬼。相同牌型下天然无鬼牌>带鬼牌'
      }
    }
  },
  computed: {
    playerName() {
      return this.$store.state.playerName || localStorage.getItem('playerName') || ''
    },
    playerId() {
      return (this.$store.state.playerId || localStorage.getItem('playerId') || '000000').slice(0, 6)
    },
    canStart() {
      return this.playerName.trim().length > 0 && this.currentUser !== null
    },
    joinRoomId() {
      return this.joinRoomDigits.join('')
    },
    requiredExtraSuitCount() {
      return Math.max(0, this.playerCount - 4)
    },
    totalExtraSuitCount() {
      return Object.values(this.extraSuitCounts).reduce((sum, count) => sum + (Number(count) || 0), 0)
    },
    shouldShowExtraSuitOptions() {
      return this.requiredExtraSuitCount > 0
    },
    userAvatarText() {
      const name = this.currentUser && (this.currentUser.nickname || this.currentUser.username)
      return name ? name.charAt(0) : ''
    },
    
  },
  watch: {
    showNameModal(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.nameInput?.focus()
        })
      }
    },
    '$route'(to) {
      if (to && to.name === 'Home' && to.query && (to.query.invite || to.query.ref || to.query.room || to.query.roomId)) {
        this.captureInviteFromRoute()
      }
    }
  },
  mounted() {
    this.inputName = this.playerName
    this.soundMuted = getMuted()
    this.loadLocalUser()
    this.captureInviteFromRoute()
    this.fetchRoundCosts()
    this.fetchDurationCosts()
    document.addEventListener('click', this.closeUserMenu)
    window.addEventListener('app-auth-expired', this.onAuthExpired)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeUserMenu)
    window.removeEventListener('app-auth-expired', this.onAuthExpired)
  },
  methods: {
    toggleSound() {
      this.soundMuted = !this.soundMuted
      setMuted(this.soundMuted)
    },

    toggleHint(key) {
      this.activeHintKey = this.activeHintKey === key ? null : key
    },

    closeAllHints() {
      this.activeHintKey = null
    },

    confirmName() {
      const name = this.inputName.trim()
      if (!name) {
        this.$message.info('请输入昵称')
        return
      }
      this.$store.commit('SET_PLAYER_NAME', name)
      localStorage.setItem('playerName', name)
      if (!this.$store.state.playerId) {
        const pid = 'p-' + Math.random().toString(36).substr(2, 9)
        this.$store.commit('SET_PLAYER_ID', pid)
        localStorage.setItem('playerId', pid)
      }
      const shouldContinueJoin = this.pendingJoinAfterName && this.showJoinModal && this.joinRoomId.length === 4
      this.pendingJoinAfterName = false
      this.showNameModal = false
      if (shouldContinueJoin) {
        this.$nextTick(() => this.doJoinRoom())
      }
    },

    openNameModal() {
      this.inputName = this.playerName
      this.showNameModal = true
    },

    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
    },

    closeUserMenu() {
      this.showUserMenu = false
    },

    loadLocalUser() {
      const userText = localStorage.getItem('appUser')
      if (userText) {
        try {
          this.currentUser = JSON.parse(userText)
          this.diamondBalance = Number(this.currentUser.diamonds || localStorage.getItem('appDiamonds') || 0)
          this.fetchDiamondBalance()
        } catch (e) {
          this.currentUser = null
        }
      }
    },

    async fetchRoundCosts() {
      try {
        const data = await appSysRequest('/round')
        if (data && data.dictsub) {
          const options = []
          data.dictsub.forEach(item => {
            const rounds = parseInt(item.dictnum)
            if (!isNaN(rounds)) {
              options.push({ value: rounds, diamondCost: Number(item.dvalue) || 0, label: item.dlabel || (rounds + '局') })
            }
            if(this.limitType === 'round' && rounds === this.rounds) {
              this.diamondCost = Number(item.dvalue) || 0
            }
          })
          this.roundOptions = options
          if (options.length > 0 && options.find(o => o.value === this.rounds) === undefined && this.limitType === 'round') {
            this.rounds = options[0].value
            this.diamondCost = options[0].diamondCost
          }
        }
      } catch (e) {
        console.error('获取局数费用配置失败:', e)
      } finally {
        this.roundCostsLoaded = true
      }
    },

    async fetchDurationCosts() {
      try {
        const data = await appSysRequest('/roundduration')
        if (data && data.dictsub) {
          const options = []
          data.dictsub.forEach(item => {
            const minutes = parseInt(item.dictnum)
            if (!isNaN(minutes)) {
              options.push({ value: minutes, diamondCost: Number(item.dvalue) || 0, label: item.dlabel || (minutes + '分钟') })
            }
            if(this.limitType === 'time' && minutes === this.durationMinutes) {
              this.diamondCost = Number(item.dvalue) || 0
            }
          })
          this.durationOptions = options
          if (options.length > 0 && options.find(o => o.value === this.durationMinutes) === undefined && this.limitType === 'time') {
            this.durationMinutes = options[0].value
            this.diamondCost = options[0].diamondCost
          }
        }
      } catch (e) {
        console.error('获取时长费用配置失败:', e)
      } finally {
        this.durationCostsLoaded = true
      }
    },



    

    /**
     * 显示确认对话框，返回 Promise。
     */
    askConfirm(message, options = {}) {
      return new Promise(resolve => {
        this.$root.$emit('show-confirm', {
          title: options.title || '提示',
          message,
          confirmText: options.confirmText || '确定',
          cancelText: options.cancelText || '取消',
          resolve
        })
      })
    },

    openAuth(mode) {
      this.authMode = mode
      this.showAuthModal = true
      this.resetAuthForm()
    },

    switchAuthMode() {
      this.authMode = this.authMode === 'login' ? 'register' : 'login'
      this.resetAuthForm()
    },

    resetAuthForm() {
      this.authForm = {
        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        nickname: ''
      }
    },

    onAuthExpired() {
      this.showRechargeModal = false
      this.showPasswordModal = false
      this.logout()
      this.openAuth('login')
    },

    async submitAuth() {
      if (this.authSubmitting) return
      try {
        const username = this.authForm.username.trim()
        const password = this.authForm.password
        if (!username) {
          this.$message.info('请输入用户名')
          return
        }
        if (!password) {
          this.$message.info('请输入密码')
          return
        }

        this.authSubmitting = true
        if (this.authMode === 'register') {
          if (password !== this.authForm.confirmPassword) {
            this.$message.info('两次输入的密码不一致')
            return
          }
          if (!this.authForm.nickname.trim()) {
            this.$message.info('请输入昵称')
            return
          }
          const referrerid = this.inviteReferrerId || localStorage.getItem('inviteReferrerId') || ''
          await appUserRequest('/reg', {
            username,
            passwordHash: md5(password),
            email: this.authForm.email.trim(),
            nickname: this.authForm.nickname.trim(),
            referrerid
          })
          localStorage.removeItem('inviteReferrerId')
          this.inviteReferrerId = ''
          this.$message.success('注册成功')
          try {
            const data = await appUserRequest('/login', { username, password: md5(password) })
            await this.applyLogin(data, username)
            return
          } catch (loginError) {
            this.authMode = 'login'
            this.authForm.password = ''
            this.authForm.confirmPassword = ''
            if (!loginError.handled) this.$message.error(loginError.message || '自动登录失败，请手动登录')
            return
          }
        }

        const data = await appUserRequest('/login', { username, password: md5(password) })
        await this.applyLogin(data, username)
      } catch (e) {
        if (!e.handled) this.$message.error(e.message)
      } finally {
        this.authSubmitting = false
      }
    },

    async applyLogin(data, username) {
      const profile = {
        id: data.userid,
        username: data.realname || username,
        nickname: data.nickname || data.realname || username,
        diamonds: 0
      }
      localStorage.setItem('appToken', data.token || '')
      localStorage.setItem('appUser', JSON.stringify(profile))
      this.currentUser = profile
      this.$store.commit('SET_PLAYER_NAME', profile.nickname)
      this.$store.commit('SET_PLAYER_ID', String(profile.id))
      localStorage.setItem('playerName', profile.nickname)
      localStorage.setItem('playerId', String(profile.id))
      this.showAuthModal = false
      this.fetchDiamondBalance()
      await this.joinInvitedRoomIfNeeded()
    },

    async fetchDiamondBalance() {
      if (!this.currentUser || !localStorage.getItem('appToken')) return
      try {
        const data = await appUserRequest('/surplus', { userid: this.currentUser.id })
        const diamonds = Number(data.user && data.user.diamonds) || 0
        this.diamondBalance = diamonds
        localStorage.setItem('appDiamonds', String(diamonds))
        const profile = { ...this.currentUser, diamonds }
        this.currentUser = profile
        localStorage.setItem('appUser', JSON.stringify(profile))
      } catch (e) {
        console.warn('查询钻石余额失败:', e)
      }
    },

    openPasswordModal() {
      if (!this.currentUser) return
      this.showUserMenu = false
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.showPasswordModal = true
    },

    async openRechargeModal() {
      if (!this.currentUser) {
        this.openAuth('login')
        return
      }
      this.showUserMenu = false
      this.showRechargeModal = true
      if (!this.rechargePlans.length) {
        await this.fetchRechargePlans()
      }
    },

    openInviteModal() {
      if (!this.currentUser) {
        this.openAuth('login')
        return
      }
      this.showUserMenu = false
      this.showInviteModal = true
    },

    captureInviteFromRoute() {
      const query = (this.$route && this.$route.query) || {}
      const inviteId = String(query.invite || query.ref || '').trim()
      const roomId = String(query.room || query.roomId || '').trim()
      const hasInviteQuery = !!(inviteId || /^\d{4}$/.test(roomId))

      if (inviteId) {
        this.inviteReferrerId = inviteId
        localStorage.setItem('inviteReferrerId', inviteId)
      } else if (!this.inviteReferrerId) {
        this.inviteReferrerId = localStorage.getItem('inviteReferrerId') || ''
      }

      if (/^\d{4}$/.test(roomId)) {
        this.pendingInviteRoomId = roomId
        localStorage.setItem('inviteRoomId', roomId)
      } else if (!this.pendingInviteRoomId) {
        this.pendingInviteRoomId = localStorage.getItem('inviteRoomId') || ''
      }

      if (!hasInviteQuery) return

      // 创建房间后的带房间号邀请：未登录也可直接进房，不必先注册/登录
      if (this.pendingInviteRoomId) {
        this.showAuthModal = false
        this.$nextTick(() => this.joinInvitedRoomIfNeeded())
        return
      }

      if (inviteId && !this.currentUser) {
        this.openAuth('login')
      }
    },

    ensureInvitePlayerIdentity() {
      if (this.currentUser) {
        const name = this.currentUser.nickname || this.currentUser.username || this.playerName || '玩家'
        const id = String(this.currentUser.id)
        this.$store.commit('SET_PLAYER_NAME', name)
        this.$store.commit('SET_PLAYER_ID', id)
        localStorage.setItem('playerName', name)
        localStorage.setItem('playerId', id)
        return
      }

      let id = this.$store.state.playerId || localStorage.getItem('playerId') || ''
      if (!id || id === '000000') {
        id = 'guest-' + Math.random().toString(36).substr(2, 9)
      }
      let name = (this.playerName || '').trim()
      if (!name) {
        const suffix = String(id).replace(/[^a-zA-Z0-9]/g, '').slice(-4) || '8888'
        name = '游客' + suffix
      }
      this.$store.commit('SET_PLAYER_NAME', name)
      this.$store.commit('SET_PLAYER_ID', String(id))
      localStorage.setItem('playerName', name)
      localStorage.setItem('playerId', String(id))
    },

    clearInviteRoom() {
      this.pendingInviteRoomId = ''
      localStorage.removeItem('inviteRoomId')
    },

    async joinInvitedRoomIfNeeded() {
      const roomId = String(this.pendingInviteRoomId || localStorage.getItem('inviteRoomId') || '').trim()
      if (!roomId || roomId.length !== 4 || this.joiningInvite) return

      const existing = this.$store.state.multiplayer.room
      if (existing && String(existing.id) === roomId) {
        this.clearInviteRoom()
        this.$router.push('/room')
        return
      }

      this.joiningInvite = true
      try {
        this.ensureInvitePlayerIdentity()
        await this.$store.dispatch('multiplayer/joinRoom', roomId)
        this.clearInviteRoom()
        this.$router.push('/room')
      } catch (e) {
        if (!e.handled) this.$message.error(e.message || '加入房间失败')
        this.clearInviteRoom()
      } finally {
        this.joiningInvite = false
      }
    },

    closeRechargeModal() {
      this.showRechargeModal = false
      this.fetchDiamondBalance()
    },

    async fetchRechargePlans() {
      try {
        this.rechargeLoading = true
        const data = await appPayRequest('/plan')
        const plans = Array.isArray(data.dictsub) ? data.dictsub : []
        this.rechargePlans = plans
          .filter(plan => plan && plan.id)
          .sort((a, b) => Number(a.dorder || 0) - Number(b.dorder || 0))
      } catch (e) {
        if (!e.handled) this.$message.error(e.message || '获取充值方案失败')
      } finally {
        this.rechargeLoading = false
      }
    },

    async createPayOrder(plan) {
      if (!this.currentUser || this.rechargeSubmittingId) return
      const amount = Number(plan.dictnum)
      const diamond = Number(plan.dvalue)
      if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(diamond) || diamond <= 0) {
        this.$message.error('充值方案数据异常')
        return
      }

      try {
        this.rechargeSubmittingId = plan.id
        const data = await appPayRequest('/createorder', {
          amount,
          diamond,
          modeid: plan.id,
          attach: plan.dlabel || ''
        })
        const order = data.order || data.payOrder || data
        const payUrl = order.payurl || order.h5url || order.pay_url || order.h5_url
        this.$message.success('支付订单创建成功')
        if (payUrl) {
          window.open(payUrl, '_blank')
        }
      } catch (e) {
        if (!e.handled) this.$message.error(e.message || '创建支付订单失败')
      } finally {
        this.rechargeSubmittingId = null
      }
    },

    async submitPasswordChange() {
      if (this.passwordSubmitting || !this.currentUser) return
      const oldPassword = this.passwordForm.oldPassword
      const newPassword = this.passwordForm.newPassword
      if (!oldPassword) {
        this.$message.info('请输入旧密码')
        return
      }
      if (!newPassword) {
        this.$message.info('请输入新密码')
        return
      }
      if (newPassword !== this.passwordForm.confirmPassword) {
        this.$message.info('两次输入的新密码不一致')
        return
      }
      try {
        this.passwordSubmitting = true
        await appUserRequest('/changepwd', {
          username: this.currentUser.username,
          oldpwd: md5(oldPassword),
          pwd: md5(newPassword)
        })
        this.$message.success('密码修改成功，请重新登录')
        this.showPasswordModal = false
        this.logout()
      } catch (e) {
        if (!e.handled) this.$message.error(e.message)
      } finally {
        this.passwordSubmitting = false
      }
    },

    logout() {
      localStorage.removeItem('appToken')
      localStorage.removeItem('appUser')
      localStorage.removeItem('appDiamonds')
      this.currentUser = null
      this.diamondBalance = 0
      this.showUserMenu = false
    },

    /**
     * 确保玩家已登录且有昵称，未满足时弹出对应弹窗。
     * 返回 true 表示可以继续操作，false 表示已弹出引导弹窗。
     */
    ensureReady() {
      if (!this.playerName.trim()) {
        this.openNameModal()
        return false
      }
      if (!this.currentUser) {
        this.openAuth('login')
        return false
      }
      return true
    },

    openCreateRoom() {
      if (!this.ensureReady()) return
      this.configMode = 'create'
      this.syncDefaultExtraSuits()
      this.showCreateModal = true
    },

    openSingleConfig() {
      if (!this.ensureReady()) return
      this.configMode = 'single'
      this.syncDefaultExtraSuits()
      this.showCreateModal = true
    },

    openJoinRoom() {
      if (!this.ensureReady()) return
      this.showJoinModal = true
    },

    setSweepScoreType(type) {
      this.sweepScoreType = type
      this.sweepScoreValue = type === 'score' ? 2 : 2
    },

    normalizeSweepScoreValue() {
      const value = Number(this.sweepScoreValue)
      this.sweepScoreValue = Number.isFinite(value) && value > 0 ? Math.floor(value) : 2
    },

    normalizeRoomOptionValues() {
      this.normalizeSweepScoreValue()
      this.yucaiScore = this.normalizePositiveInteger(this.yucaiScore, 0)
      this.roomRatePercent = this.normalizePositiveInteger(this.roomRatePercent, 2)
      Object.keys(this.specialScores).forEach(key => {
        this.specialScores[key] = Math.max(
          1,
          this.normalizePositiveInteger(this.specialScores[key], this.getDefaultSpecialScore(key))
        )
      })
      Object.keys(this.rowSpecialScores).forEach(key => {
        this.rowSpecialScores[key] = Math.max(
          1,
          this.normalizePositiveInteger(this.rowSpecialScores[key], this.getDefaultRowSpecialScore(key))
        )
      })
      this.normalizeExtraSuitCounts()
    },

    normalizeExtraSuitCounts() {
      const required = this.requiredExtraSuitCount
      if (required <= 0) {
        this.extraSuitCounts = {
          hearts: 0,
          spades: 0,
          clubs: 0,
          diamonds: 0
        }
        this.selectedExtraSuits = []
        return
      }

      const total = this.totalExtraSuitCount
      if (total === required) {
        this.selectedExtraSuits = this.expandExtraSuits()
        return
      }

      if (total === 0) {
        this.syncDefaultExtraSuits()
        return
      }

      const next = { ...this.extraSuitCounts }
      if (total > required) {
        let toRemove = total - required
        for (let i = this.extraSuitOptions.length - 1; i >= 0 && toRemove > 0; i--) {
          const suit = this.extraSuitOptions[i].value
          const removable = Math.min(Number(next[suit]) || 0, toRemove)
          next[suit] = (Number(next[suit]) || 0) - removable
          toRemove -= removable
        }
      } else {
        let remaining = required - total
        for (const suit of this.extraSuitOptions) {
          if (remaining <= 0) break
          next[suit.value] = (Number(next[suit.value]) || 0) + 1
          remaining--
        }
      }

      this.extraSuitCounts = next
      this.selectedExtraSuits = this.expandExtraSuits()
    },

    getDefaultRowSpecialScore(key) {
      const defaults = {
        frontThreeKind: 3,
        middleFullHouse: 2,
        middleFourKind: 8,
        middleStraightFlush: 10,
        middleFiveKind: 20,
        backFourKind: 4,
        backStraightFlush: 5,
        backFiveKind: 10
      }
      return defaults[key] || 1
    },

    expandExtraSuits() {
      const expanded = []
      this.extraSuitOptions.forEach(suit => {
        const count = Math.max(0, Number(this.extraSuitCounts[suit.value]) || 0)
        for (let i = 0; i < count; i++) {
          expanded.push(suit.value)
        }
      })
      return expanded
    },

    normalizePositiveInteger(value, fallback) {
      const numberValue = Number(value)
      return Number.isFinite(numberValue) && numberValue >= 0 ? Math.floor(numberValue) : fallback
    },

    getDefaultSpecialScore(key) {
      const defaults = {
        dragonScore: 15,
        allBigScore: 10,
        allSmallScore: 10,
        sixPairsHalfScore: 7,
        threeFlushScore: 7,
        threeStraightScore: 7
      }
      return defaults[key] || 1
    },

    buildRoomConfigPayload() {
      return {
        playerCount: this.playerCount,
        baseScore: this.baseScore,
        arrangeTime: this.arrangeTime,
        enableRandomSeat: this.enableRandomSeat,
        enableIpLimit: this.enableIpLimit,
        enableSpecialHands: this.enableSpecialHands,
        enableHomeRun: this.enableHomeRun,
        allowOddCards: this.allowOddCards,
        allowFouled: this.allowFouled,
        enableHorse: this.enableHorse,
        horseSuit: this.horseSuit,
        horseRank: this.horseRank,
        enableYucai: this.enableYucai,
        yucaiScore: this.yucaiScore,
        allowRoomRate: this.allowRoomRate,
        roomRatePercent: this.roomRatePercent,
        ...this.specialScores,
        sweepScoreType: this.sweepScoreType,
        sweepScoreValue: this.sweepScoreValue,
        dealMode: this.dealMode,
        ghostMode: this.ghostMode,
        roundCount: this.rounds,
        limitType: this.limitType,
        durationMinutes: this.durationMinutes,
        extraSuits: this.expandExtraSuits(),
        rowSpecialScores: { ...this.rowSpecialScores },
        rounds: this.rounds,
        diamondCost: this.diamondCost
      }
    },

    selectRoundLimit(rounds, diamondCost) {
      this.limitType = 'round'
      this.rounds = rounds
      this.diamondCost = diamondCost
    },

    selectTimeLimit(minutes, diamondCost) {
      this.limitType = 'time'
      this.durationMinutes = minutes
      this.diamondCost = diamondCost
    },

    selectPlayerCount(count) {
      this.playerCount = count
      this.syncDefaultExtraSuits()
    },

    syncDefaultExtraSuits() {
      const required = this.requiredExtraSuitCount
      const next = {
        hearts: 0,
        spades: 0,
        clubs: 0,
        diamonds: 0
      }

      if (required <= 0) {
        this.extraSuitCounts = next
        this.selectedExtraSuits = []
        return
      }

      let remaining = required
      for (const suit of this.extraSuitOptions) {
        if (remaining <= 0) break
        next[suit.value] = 1
        remaining--
      }

      this.extraSuitCounts = next
      this.selectedExtraSuits = this.expandExtraSuits()
    },

    canIncreaseExtraSuit(suit) {
      const required = this.requiredExtraSuitCount
      if (required <= 0) return false
      if (this.totalExtraSuitCount >= required) return false
      if (required === 1) return (this.extraSuitCounts[suit] || 0) === 0
      return true
    },

    canDecreaseExtraSuit(suit) {
      return (this.extraSuitCounts[suit] || 0) > 0
    },

    changeExtraSuitCount(suit, delta) {
      const required = this.requiredExtraSuitCount
      if (required <= 0) return

      const current = Number(this.extraSuitCounts[suit]) || 0
      const nextValue = current + delta
      if (nextValue < 0) return

      if (required === 1) {
        const next = { hearts: 0, spades: 0, clubs: 0, diamonds: 0 }
        if (delta > 0) next[suit] = 1
        this.extraSuitCounts = next
        this.selectedExtraSuits = this.expandExtraSuits()
        return
      }

      const projectedTotal = this.totalExtraSuitCount - current + nextValue
      if (projectedTotal > required) return

      this.extraSuitCounts = {
        ...this.extraSuitCounts,
        [suit]: nextValue
      }
      this.selectedExtraSuits = this.expandExtraSuits()
    },

    selectExtraSuit(suit) {
      this.changeExtraSuitCount(suit, this.extraSuitCounts[suit] ? 0 : 1)
    },

    async confirmConfig() {
      if (!this.ensureReady()) {
        this.showCreateModal = false
        return
      }
      this.normalizeRoomOptionValues()
      this.$root.$emit('request-fullscreen')
      localStorage.setItem('playerName', this.playerName)
      localStorage.setItem('playerId', this.$store.state.playerId)

      if (this.configMode === 'create') {
        const cost = this.diamondCost
        if (cost > 0 && this.diamondBalance < cost) {
          this.showCreateModal = false
          const roomDesc = this.limitType === 'time'
            ? (this.durationOptions.find(o => o.value === this.durationMinutes)?.label || `${this.durationMinutes}分钟`)
            : `${this.rounds}局`
          const confirmed = await this.askConfirm(
            `创建 ${roomDesc} 房间需要消耗 ${cost} 钻石，当前余额 ${this.diamondBalance} 钻石，不足。是否去充值？`,
            { confirmText: '去充值', cancelText: '取消' }
          )
          if (confirmed) {
            this.openRechargeModal()
          }
          return
        }
        try {
          const room = await this.$store.dispatch('multiplayer/createRoom', this.buildRoomConfigPayload())
          this.showCreateModal = false
          this.fetchDiamondBalance()
          this.$router.push('/room')
        } catch (e) {
          if (!e.handled) this.$message.error(e.message || '创建房间失败')
        }
      } else {
        this.$store.dispatch('initGame', {
          playerName: this.playerName,
          aiCount: this.playerCount - 1
        })

        this.$store.commit('SET_CONFIG', this.buildRoomConfigPayload())

        this.showCreateModal = false
        this.$router.push('/game')
      }
    },

    inputDigit(n) {
      if (this.joinRoomDigits.length < 4) {
        this.joinRoomDigits.push(n)
      }
      if (this.joinRoomDigits.length === 4) {
        this.doJoinRoom()
      }
    },

    deleteDigit() {
      this.joinRoomDigits.pop()
    },

    clearDigits() {
      this.joinRoomDigits = []
    },

    async doJoinRoom() {
      if (!this.ensureReady()) {
        this.pendingJoinAfterName = this.joinRoomId.length === 4
        return
      }
      const roomId = this.joinRoomId
      if (!roomId || roomId.length !== 4) return

      localStorage.setItem('playerName', this.playerName)
      localStorage.setItem('playerId', this.$store.state.playerId)

      try {
        await this.$store.dispatch('multiplayer/joinRoom', roomId)
        this.showJoinModal = false
        this.joinRoomDigits = []
        this.$router.push('/room')
      } catch (e) {
        if (!e.handled) this.$message.error(e.message || '加入房间失败')
        this.joinRoomDigits = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/homeback.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  /* 深色遮罩，让文字更清晰 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    pointer-events: none;
  }
}

/* 顶部栏 */
.top-bar {
  // position: relative;
  position: absolute;
  width: 100%;
  z-index: 20;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 20px;
  background: linear-gradient(180deg, rgba(0,0,0,0.4) 0%, transparent 100%);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 140px;
  padding: 4px 10px 4px 4px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  z-index: 21;
  margin-right: auto;
  pointer-events: auto;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255,255,255,0.1);
  }

  .avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffd700, #ff8c00);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: #1a1a2e;
    border: 2px solid rgba(255, 215, 0, 0.5);
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 3px 12px rgba(255, 215, 0, 0.35);
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;

    .name-row {
      .name {
        color: #ffd700;
        font-size: 15px;
        font-weight: bold;
        text-shadow: 0 1px 3px rgba(0,0,0,0.5);
        display: block;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .id-row {
      .id {
        color: rgba(255,255,255,0.6);
        font-size: 12px;
      }
    }
  }

  .user-menu {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 30;
    width: 132px;
    padding: 6px;
    border: 1px solid rgba(255,215,0,0.28);
    border-radius: 8px;
    background: rgba(18, 18, 32, 0.94);
    box-shadow: 0 12px 30px rgba(0,0,0,0.38);
    backdrop-filter: blur(8px);
  }

  .user-menu-item {
    width: 100%;
    height: 34px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: rgba(255,255,255,0.88);
    font-size: 13px;
    cursor: pointer;
    text-align: left;
    padding: 0 10px;

    &:hover {
      background: rgba(255,215,0,0.14);
      color: #ffd700;
    }
  }

  .user-menu-divider {
    height: 1px;
    margin: 6px 4px;
    background: rgba(255,255,255,0.14);
  }
}

.top-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;

  .icon-btn {
    padding: 6px 14px;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 16px;
    background: rgba(255,255,255,0.08);
    color: rgba(255,255,255,0.9);
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255,255,255,0.15);
      border-color: rgba(255,215,0,0.4);
      color: #ffd700;
    }

    &.auth-primary {
      border-color: rgba(255,215,0,0.45);
      color: #1a1a2e;
      background: linear-gradient(135deg, #ffd700, #ff8c00);
    }
  }
}

.home-main-stack {
  position: relative;
  z-index: 2;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Logo区 */
.logo-section {
  position: relative;

  z-index: 2;
  text-align: center;
  padding: 30px 0 4px;
}

.game-logo {
  display: inline-block;

  .logo-main {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    img.logo-image {
      // width: 120px;
      height: 120px;
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.4));
    }

  }

}

/* 公告 */
.notice-bar {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 16px;
  margin: 0 16px;
  background: rgba(0,0,0,0.25);
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.4);

  .notice-icon {
    font-size: 14px;
  }

  .notice-text {
    color: rgba(255,255,255,0.7);
    font-size: 13px;
  }
}

/* 主内容区 */
.main-content {
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px 16px;
  min-height: 0;
  overflow-y: auto;
}

/* 按钮区 */
.action-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  min-width: 0;
  // padding: 8px 0;
  
}

.main-btn {
  position: relative;
  width: 100%;
  max-width: 240px;
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  // gap: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
  // box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  flex-shrink: 0;

  background: url('@/assets/images/btn1.png') no-repeat center center;
  // background-size: cover;
  background-size: contain;

  &:hover {
    transform: translateY(-3px) scale(1.02);
    // box-shadow: 0 8px 25px rgba(0,0,0,0.4);
  }

  &:active {
    transform: translateY(-1px) scale(0.98);
  }

  .btn-icon {
    width: 24px;
    height: 24px;
    img {
      width: 100%;
      height: 100%;
    } 
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.3));
  }

  

  .btn-text {
    font-size: 20px;
    font-weight: bold;
    font-family: 'Arial Black', 'Impact', 'Arial', sans-serif;
    color: #F5E6C8;
    text-shadow:
        -2px -2px 0 #6B1220,
        2px -2px 0 #6B1220,
        -2px 2px 0 #6B1220,
        2px 2px 0 #6B1220,
        0 -2px 0 #6B1220,
        0 2px 0 #6B1220,
        -2px 0 0 #6B1220,
        2px 0 0 #6B1220,
        0 3px 4px rgba(107, 18, 32, 0.3);
    line-height: 1;
    user-select: none;

  }
}

.create-btn {
  // background: linear-gradient(135deg, #ffd700 0%, #ff8c00 100%);
  color: #4a2600;
  // border: 2px solid rgba(255,215,0,0.5);
}

.join-btn {
  // background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  // border: 2px solid rgba(231, 76, 60, 0.5);
}

.single-btn {
  // background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  color: white;
  // border: 2px solid rgba(155, 89, 182, 0.5);
}

/* 音效开关按钮 */
.sound-toggle-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.2);
  background: rgba(255,255,255,0.1);
  color: white;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(4px);

  &:hover {
    background: rgba(255,255,255,0.2);
    transform: scale(1.05);
  }

  &.muted {
    background: rgba(231, 76, 60, 0.3);
    border-color: rgba(231, 76, 60, 0.5);
    color: #e74c3c;

    &:hover {
      background: rgba(231, 76, 60, 0.4);
    }
  }
}

/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(4px);
}

/* 创建房间弹窗 */
.create-room-modal {
  background-color: rgba(17, 127, 48, 0.3);
  border: 30px solid transparent;
  border-top: 50px solid transparent;
  border-image: url('@/assets/images/room_bk_680_1.png') 50 30 30 30  fill;

  border-radius: 36px;
  
  width: 100%;
  max-width: 658px;
  max-height: 88vh;

  display: flex;
  flex-direction: column;
  // overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);

  position: relative;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  position: absolute;

  width: 192px;
  height: 53px;

  top: -74px;
  left: 50%;
  transform: translateX(-50%);
  background: url('@/assets/images/room_tit_bk.png') no-repeat center / contain;

  

  h2 {
    flex: 1;
    text-align: center;
    color: #f9e098;
    font-size: 24px;
    font-weight: bold;

    margin: 0;
    text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  }
}

.back-btn {
    position: absolute;
    left: -8px;
    top: -32px;
    width: 36px;
    height: 36px;
    // border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    // background: rgba(255,255,255,0.08);
    color: white;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    img{
      width: 60%;
      height: 60%;
    }
    &:hover {
      background: rgba(255,255,255,0.15);
      border-color: #ffd700;
      color: #ffd700;
      transform: translateY(-2px);
    }
  }

.modal-body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.config-area {
  flex: 1;
  padding: 30px 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.config-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  .config-label {
    width: 100px;
    flex-shrink: 0;
    color: #f9e098;
    font-size: 14px;
    font-weight: bold;
    padding-top: 6px;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  }

  .hint-label {
    cursor: pointer;
    position: relative;
    user-select: none;

    .hint-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 15px;
      margin-left: 4px;
      border-radius: 50%;
      background: rgba(255,255,255,0.2);
      color: #f9e098;
      font-size: 10px;
      font-weight: bold;
      vertical-align: middle;
      transition: background 0.2s;

      &:hover {
        background: rgba(255,255,255,0.4);
      }
    }

    .hint-tooltip {
      position: absolute;
      left: 0;
      top: 100%;
      margin-top: 6px;
      width: 240px;
      padding: 10px 14px;
      background: rgba(0, 0, 0, 0.9);
      border: 1px solid #f9e098;
      border-radius: 8px;
      color: #f3ce99;
      font-size: 12px;
      font-weight: normal;
      line-height: 1.6;
      z-index: 100;
      box-shadow: 0 4px 16px rgba(0,0,0,0.5);
      white-space: normal;
    }
  }

  .config-options {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &.score-mode-options {
      flex: 0 0 auto;
    }

    &.score-value-options {
      min-width: 180px;
    }
  }
}

.score-input-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border-radius: 18px;

}

.score-input {
  width: 58px;
  border: 0;
  outline: none;
  background: rgba(0, 0, 0, 0.28);
  border: 1px solid #fff5d0;
  color: #fff7d5;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  border-radius: 8px;
  line-height: 24px;
}

.score-input-unit {
  color: #f3ce99;
  font-size: 14px;
  font-weight: bold;
}

.extra-suit-row {
  align-items: flex-start;
}

.extra-suit-config {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex: 1;
}

.extra-suit-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 18px;
  background: linear-gradient(180deg, #e2b782,#5a422d, #624831);
  box-shadow:
    0 0 0 1px #9e7f69,
    0 0 0 2px #f2c792,
    0 10px 10px 1px #000,
    inset 0 0 2px 1px #f2c792;
}

.extra-suit-btn {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.28);
  color: #fff7d5;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
}

.extra-suit-count {
  min-width: 18px;
  text-align: center;
  color: #fff7d5;
  font-size: 15px;
  font-weight: bold;
}

.extra-suit-summary {
  width: 100%;
  color: #f3ce99;
  font-size: 13px;
  font-weight: bold;
}

.suit-symbol {
  font-size: 18px;
  font-weight: 900;
  line-height: 1;

  &.red { color: #ff4d4f; }
  &.black { color: #000; }
}

.odd-card-score-options {
  gap: 8px 10px;
}

.check-option {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px 6px;
  
  // background: rgba(255,255,255,0.06);
  
  // border: 2px solid #7a5933;
  color: #f3ce99;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  border-radius: 18px;
  background: linear-gradient(180deg, #e2b782,#5a422d, #624831);
  box-shadow: 
      0 0 0 1px #9e7f69,
      0 0 0 2px #f2c792,
      0 10px 10px 1px #000,
      inset 0 0 2px 1px #f2c792
      ;

  &:hover {
    background: linear-gradient(180deg, #728e5c,#41583c, #485f41);
    box-shadow: 
      0 0 0 1px #485f41,
      0 0 0 2px #f2c792,
      0 10px 10px 1px #000,
      inset 0 0 2px 1px #728e5c
      ;
  }

  &.active {
    background: linear-gradient(180deg, #728e5c,#41583c, #485f41);
    border-color: rgba(46, 204, 113, 0.5);
    color: #f3ce99;

    box-shadow: 
      0 0 0 1px #485f41,
      0 0 0 2px #f2c792,
      0 10px 10px 1px #000,
      inset 0 0 2px 1px #728e5c
      ;

    .check-box {
      // background: linear-gradient(135deg, #2ecc71, #27ae60);
      // border-color: #2ecc71;
      color: #f3ce99;
    }
  }

  &.disabled {
    cursor: default;
    opacity: 0.78;
  }

  .check-box {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 2px solid #f3ce99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: transparent;
    transition: all 0.3s ease;
    flex-shrink: 0;
  }

  .card-face {
    font-size: 16px;
    font-weight: bold;

    &.spade { color: #fff; }
  }
}

.modal-footer {
  // padding: 16px 20px;
  // border-top: 1px solid rgba(255,255,255,0.1);
  display: flex;
  justify-content: center;

  position: absolute;
  bottom: -48px;
  left: 50%;
  transform: translateX(-50%);

  width: 135px;
  height: 41px;
  background: url('@/assets/images/room_btn_bk.png') no-repeat center / contain;
}

.create-submit-btn {
  border: none;
  color: #f9e098;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 2px;

  background: transparent;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

/* 加入房间弹窗 */
.join-room-modal {
  // background: linear-gradient(180deg, #3d2b1f 0%, #2a1d15 100%);
  border-radius: 16px;
  // border: 1px solid rgba(210, 180, 140, 0.3);
  border: 28px solid transparent;
  border-top: 38px solid transparent;
  border-image: url('@/assets/images/room_add_bk1.png') 38 28 28 28 stretch;
  border-radius: 16px;

  background-image: url('@/assets/images/room_add_bk1.png') ;
  background-repeat: no-repeat;
  background-position-x: 50%;
  background-position-y: 50%;
  background-clip: padding-box;

  width: 100%;
  max-width: 540px;
  padding: 0;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  position: relative;

  .close-btn {
    position: absolute;
    left: -8px;
    top: -20px;
    width: 36px;
    height: 36px;
    // border: 3px solid #eab57d;
    border-radius: 50%;
    background: rgba(234,181,125,0.5);
    color: white;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    img{
      width: 60%;
      height: 60%;
    }
    &:hover {
      background: rgba(234,181,125,1);
      border-color: #d09c00;
      color: #ffd700;
      transform: translateY(-2px);
    }
  }
}

.join-header {
  position: absolute;

  top: -58px;
  left: 50%;
  transform: translateX(-50%);
  background: url('@/assets/images/room_add_tit.png') no-repeat center / contain;

  width: 210px;
  height: 49px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}



.join-subtitle {
  text-align: center;
  color: #6a3211;
  font-weight: bold;

  font-size: 13px;
  margin-bottom: 10px;
}

.room-code-display {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;

  .code-box {
    width: 56px;
    height: 56px;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(219,186,155,1), rgba(219,186,155,1));
    border: 1px solid rgba(210, 180, 140, 0.3);
    box-shadow: 0 1px 2px 1px rgba(255, 255, 255, 0.8),
    inset 0 3px 3px 0 rgba(0,0,0,0.3);
    // background: url('@/assets/images/room_add_code_bk.png') no-repeat center / contain;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: bold;
    color: rgba(255,255,255,0.3);
    transition: all 0.3s ease;

    &.filled {
      border-color: #6a3211;
      color: #6a3211;
      background: linear-gradient(180deg, rgba(255,215,0,0.1), rgba(255,140,0,0.1));
      box-shadow: 0 0 15px rgba(255,215,0,0.15);
    }
  }
}

.num-keyboard {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .num-row {
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .num-btn {
    position: relative;
    width: 100px;
    height: 50px;
    // border: 1px solid rgba(255,255,255,0.15);
    border-radius: 20px;
    // background: linear-gradient(180deg, rgba(255,255,255,0.1), rgba(255,255,255,0.04));
    // background: url('@/assets/images/room_add_num_bk.png') no-repeat;

    display: flex;
    align-items: center;
    justify-content: center;

    box-shadow:
        inset 0 -1px 0 1px #a76024,
        inset 0 0 0 3px #fce5a1,
          
        inset 0 -1px 0 5px  #5b2a0e,
        inset 0 -8px 0 0  #b09274,
        inset 0 -10px 5px 4px  rgba(255,255,255,0.5),
        /* 底部投影 - 立体感 */
        0 0 0px 1px #755a32;
    
    /* 橙红渐变主体 */
    background: linear-gradient(
        180deg,
        #d1b69b 0%,
        #d1b69b 70%,
        #b09274 100%
    );

    cursor: pointer;
    transition: all 0.15s ease;
    // box-shadow: 0 2px 6px rgba(0,0,0,0.2);

    overflow: hidden;

    // 文字
    font-size: 32px;
    font-weight: 900;
    font-family: 'Arial Black', 'Impact', 'Arial', sans-serif;
    color: #F5E6C8;
    text-shadow:
        -2px -2px 0 #6B1220,
        2px -2px 0 #6B1220,
        -2px 2px 0 #6B1220,
        2px 2px 0 #6B1220,
        0 -2px 0 #6B1220,
        0 2px 0 #6B1220,
        -2px 0 0 #6B1220,
        2px 0 0 #6B1220,
        0 3px 4px rgba(107, 18, 32, 0.3);
    line-height: 1;
    user-select: none;

    &:hover {
      background: linear-gradient(180deg, rgba(255,255,255,0.15), rgba(255,255,255,0.08));
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(1px);
      box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    }

    &.func-btn {
      font-size: 24px;
      background: linear-gradient(180deg, rgba(231, 76, 60, 0.2), rgba(192, 57, 43, 0.1));
      border-color: rgba(231, 76, 60, 0.3);
      // color: #e74c3c;

      &:hover {
        background: linear-gradient(180deg, rgba(231, 76, 60, 0.3), rgba(192, 57, 43, 0.15));
      }
    }
    &.func-btn-delete{
      background: linear-gradient(
        180deg,
        #f00 0%,
        #f00 100%
      );
      box-shadow:
        inset 0 -1px 0 1px #81281a,
        inset 0 0 0 3px #fce5a1,
          
        inset 0 -1px 0 5px  #81281a,
        inset 0 -8px 0 0  #a23929,
        inset 0 -10px 3px 2px  rgba(255,255,255,0.3),
        /* 底部投影 - 立体感 */
        0 0 0px 1px #755a32;
    }

    &.func-btn-enter{
      background: linear-gradient(
        180deg,
        #FFef00  0%,
        #FFef00 100%
      );
      box-shadow:
        inset 0 -1px 0 1px #ab5f23,
        inset 0 0 0 3px #fce5a1,
          
        inset 0 -1px 0 5px  #ab5f23,
        inset 0 -8px 0 0  #ab5f23,
        inset 0 -10px 3px 2px  rgba(255,255,255,0.3),
        /* 底部投影 - 立体感 */
        0 0 0px 1px #755a32;
    }
  }
}

.num-btn::before{
  content: '';
  position: absolute;
  top: -28%;
  left: 50%;
  transform: translateX(-50%) rotateX(60deg);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(
      180deg,
      rgba(255,255,255,0.1) 0%,
      rgba(255,255,255,0.2) 40%,
      rgba(255,255,255,0.3) 100%
  );
  pointer-events: none;
}

.num-btn::after{
  content: '';
            position: absolute;
            top: 10px;
            left: 10px;
            width: 18px;
            height: 10px;
            background: rgba(255,255,255,0.8);
            border-radius: 50%;
            transform: rotate(-35deg);
            pointer-events: none;
            box-shadow: 
                0 0 6px rgba(255,255,255,0.5);
}
/* 规则弹窗 */
.rules-modal {
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 24px;
  max-width: 520px;
  max-height: 80vh;
  width: 100%;
  overflow-y: auto;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

.rules-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h2 {
    color: #ffd700;
    margin: 0;
    flex: 1;
    text-align: center;
  }

  .close-btn {
    width: 32px;
    height: 32px;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    background: rgba(255,255,255,0.08);
    color: rgba(255,255,255,0.8);
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(231, 76, 60, 0.2);
      border-color: rgba(231, 76, 60, 0.5);
      color: #e74c3c;
    }
  }
}

.rules-body {
  h3 {
    color: rgba(255,255,255,0.9);
    margin: 16px 0 8px;
    font-size: 16px;
  }

  ul {
    color: rgba(255,255,255,0.7);
    padding-left: 20px;
    margin: 0;

    li {
      margin-bottom: 6px;
      line-height: 1.5;
    }
  }

  strong {
    color: #ffd700;
  }
}

/* 昵称弹窗 */
.name-modal {
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 24px;
  max-width: 360px;
  width: 100%;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);

  .name-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      color: #ffd700;
      margin: 0;
      flex: 1;
      text-align: center;
    }

    .close-btn {
      width: 32px;
      height: 32px;
      border: 1px solid rgba(255,255,255,0.2);
      border-radius: 50%;
      background: rgba(255,255,255,0.08);
      color: rgba(255,255,255,0.8);
      font-size: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: rgba(231, 76, 60, 0.2);
        border-color: rgba(231, 76, 60, 0.5);
        color: #e74c3c;
      }
    }
  }

  .name-modal-body {
    display: flex;
    gap: 10px;

    input {
      flex: 1;
      padding: 12px 16px;
      border: 2px solid rgba(255,215,0,0.3);
      border-radius: 8px;
      background: rgba(0,0,0,0.3);
      color: white;
      font-size: 16px;

      &:focus {
        outline: none;
        border-color: #ffd700;
      }

      &::placeholder {
        color: rgba(255,255,255,0.4);
      }
    }

    .confirm-name-btn {
      padding: 12px 20px;
      border: none;
      border-radius: 8px;
      background: linear-gradient(135deg, #ffd700, #ff8c00);
      color: #1a1a2e;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(255,215,0,0.3);
      }
    }
  }
}

.auth-modal {
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 24px;
  max-width: 380px;
  width: 100%;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);

  .auth-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      color: #ffd700;
      margin: 0;
    }

    .close-btn {
      width: 32px;
      height: 32px;
      border: 1px solid rgba(255,255,255,0.2);
      border-radius: 50%;
      background: rgba(255,255,255,0.08);
      color: rgba(255,255,255,0.8);
      font-size: 20px;
      cursor: pointer;
    }
  }

  .auth-body {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .auth-invite-tip {
      margin: 0;
      padding: 8px 10px;
      border-radius: 8px;
      background: rgba(255, 215, 0, 0.12);
      color: #ffd700;
      font-size: 13px;
      line-height: 1.5;
      text-align: center;
    }

    input {
      padding: 12px 16px;
      border: 2px solid rgba(255,215,0,0.3);
      border-radius: 8px;
      background: rgba(0,0,0,0.3);
      color: white;
      font-size: 15px;

      &:focus {
        outline: none;
        border-color: #ffd700;
      }

      &::placeholder {
        color: rgba(255,255,255,0.4);
      }
    }
  }

  .captcha-row {
    display: grid;
    grid-template-columns: 1fr 112px;
    gap: 8px;
  }

  .captcha-btn,
  .link-btn {
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 8px;
    background: rgba(255,255,255,0.08);
    color: #ffd700;
    cursor: pointer;
  }

  .auth-switch {
    text-align: right;
  }

  .link-btn {
    padding: 0;
    border: none;
    background: transparent;
    font-size: 13px;
  }

  .confirm-name-btn {
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #ffd700, #ff8c00);
    color: #1a1a2e;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;

    &:disabled {
      cursor: default;
      opacity: 0.72;
    }
  }
}

.recharge-modal {
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border-radius: 16px;
  padding: 24px;
  width: min(100%, 720px);
  max-height: calc(100vh - 40px);
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .auth-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      color: #ffd700;
      margin: 0;
    }

    .close-btn {
      width: 32px;
      height: 32px;
      border: 1px solid rgba(255,255,255,0.2);
      border-radius: 50%;
      background: rgba(255,255,255,0.08);
      color: rgba(255,255,255,0.8);
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.recharge-body {
  min-height: 168px;
  overflow-y: auto;
  padding-right: 4px;
}

.recharge-empty {
  min-height: 168px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.72);
  font-size: 14px;
}

.recharge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  padding-top: 10px;
}

.recharge-plan {
  min-height: 104px;
  border: 1px solid rgba(255,215,0,0.36);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(255,215,0,0.16), rgba(255,140,0,0.08));
  color: #fff7d5;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    border-color: rgba(255,215,0,0.72);
    background: linear-gradient(180deg, rgba(255,215,0,0.24), rgba(255,140,0,0.12));
  }

  &:disabled {
    cursor: default;
    opacity: 0.72;
  }
}

.recharge-title {
  color: #ffd700;
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
}

.recharge-diamond {
  color: rgba(255,255,255,0.84);
  font-size: 14px;
}

.recharge-action {
  min-width: 84px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, #ffd700, #ff8c00);
  color: #1a1a2e;
  font-size: 13px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .top-bar {
    padding: 8px 12px;
  }

  .user-info .avatar {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .game-logo .logo-main h1 {
    font-size: 24px;
    letter-spacing: 3px;
  }

  .game-logo .logo-deco {
    font-size: 20px;
  }

  .notice-bar {
    margin: 0 12px;
    padding: 6px 12px;

    .notice-text {
      font-size: 11px;
    }
  }

  .logo-section {
    padding: 6px 0 2px;

    img.logo-image {
      height: 56px;
    }
  }

  .main-content {
    padding: 8px 12px 12px;
    align-items: flex-start;
  }

  .action-panel {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .main-btn {
    max-width: 200px;
    padding: 10px 14px;
    font-size: 15px;

    .btn-icon {
      font-size: 20px;
    }
  }

  .create-room-modal {
    max-height: 90vh;
  }

  .modal-body {
    overflow-y: auto;
  }

  .config-area {
    padding: 12px;
  }

  .config-row {
    flex-direction: column;
    gap: 8px;

    .config-label {
      width: auto;
      padding-top: 0;
    }
  }

  .join-room-modal {
    padding: 16px;
  }

  .room-code-display .code-box {
    width: 48px;
    height: 56px;
    font-size: 24px;
  }

  .num-keyboard .num-btn {
    width: 64px;
    height: 48px;
    font-size: 20px;
  }

  .recharge-modal {
    width: 100%;
    max-height: calc(100vh - 24px);
    padding: 18px;
  }

  .recharge-grid {
    grid-template-columns: repeat(auto-fit, minmax(126px, 1fr));
  }
}

@media (max-width: 768px) and (orientation: portrait) {
  .home-main-stack {
    min-height: 100%;
    justify-content: center;
    padding: 74px 0 28px;
    box-sizing: border-box;
    transform: translateY(5vh);
  }

  .logo-section {
    padding: 0 0 10px;

    img.logo-image {
      height: 92px;
    }
  }

  .notice-bar {
    margin: 8px 18px 14px;
  }

  .main-content {
    flex: 0 0 auto;
    align-items: center;
    overflow: visible;
    padding: 0 12px;
  }

  .action-panel {
    flex: 0 0 auto;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 10px;
    width: 100%;
  }

  .main-btn {
    width: min(78vw, 240px);
    max-width: 240px;
  }
}

@media (max-width: 480px) {
  .main-btn {
    max-width: 100%;
  }

  .num-keyboard .num-btn {
    width: 56px;
    height: 44px;
    font-size: 18px;
  }

  .recharge-plan {
    min-height: 92px;
  }
}
</style>
